import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import swal from "sweetalert";
import AddIcon from "@mui/icons-material/Add";
import "../../styles/modal.css";
import { api_path } from "../../shared";
import Grid from "@material-ui/core/Grid";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import Container from "@material-ui/core/Container";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import axios from "axios";
function AddServiceDataModal(props) {
  const token = process.env.REACT_APP_API_TOKEN;
  const [polList, setPolList] = useState([]);
  const [podList, setPodList] = useState([]);
  const [delList, setDelList] = useState([]);
  const [show, setShow] = useState(false);
  const [isDisabled, setDisabled] = useState(false);
  useEffect(() => {
    console.log(props.CUSTOMER_CODE);
    if (props.CUSTOMER_CODE > 0) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
    fetchPort();
  }, []);
  const [GET_POL, SET_POL] = useState(null);
  const [GET_POD, SET_POD] = useState(null);
  const [GET_DEL, SET_DEL] = useState(null);
  const [GET_20, SET_20] = useState(null);
  const [GET_40, SET_40] = useState(null);
  const [GET_20F, SET_20F] = useState(null);
  const [GET_40F, SET_40F] = useState(null);
  const [GET_40HQ, SET_40HQ] = useState(null);
  const [GET_45, SET_45] = useState(null);
  const [GET_ISOTANK, SET_ISOTANK] = useState(null);
  const [GET_SPECIAL, SET_SPECIAL] = useState(null);
  const [GET_CBM, SET_CBM] = useState(null);
  const [errors, setErrors] = useState({});
  const handleSubmit = (e) => {
    e.preventDefault();
    var data = {
      CRM_CUSCODE: props.CUSTOMER_CODE,
      LOADPORT: GET_POL,
      DISCHARGE_PORT: GET_POD,
      FINAL_PORT: GET_DEL,
      T20: GET_20,
      T40: GET_40,
      T40HQ: GET_40HQ,
      T45: GET_45,
      R20: GET_20F,
      R40: GET_40F,
      ISOTANK: GET_ISOTANK,
      SPECIAL: GET_SPECIAL,
      LCL_CBM: GET_CBM,
    };
    //console.log("data...", data);
    fetch(`${api_path}/customer/customer_details.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status == "200") {
          swal("Done", "Save data successfully", "success").then(() => {
            if (props.PAGE == "GRID") {
              // 1. ปิด modal
              props.onClose();
              // 2. แจ้ง parent ให้ refresh datagrid
              if (props.onSaveSuccess) props.onSaveSuccess();
            } else {
              window.location = `./customer?customer_id=${props.CUSTOMER_CODE}`;
            }
          });
        } else {
          swal("Sorry", result.message, "error");
        }
      });
  };
  const fetchPort = () => {
    axios
      .get(api_path + `/MS_ISO_PORT.php?GETALLPORT=1`)
      .then((response) => {
        setPolList(response.data);
        setPodList(response.data);
        setDelList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  function handleShow() {
    if (props.CUSTOMER_CODE > 0) {
      setShow(true);
    } else {
      setDisabled(true);
    }
  }
  const filterOptions = createFilterOptions({
    ignoreCase: true,
    matchFrom: "any",
    limit: 500,
    stringify: (option: FilmOptionType) => option.label,
  });

  return (
    <>
      <button
        onClick={handleShow}
        disabled={isDisabled}
        className="btn btn-primary btn-sm"
      >
        <AddIcon sx={{ fontSize: 16 }} />
        Add Services
      </button>

      <Modal
        className="modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Services Use</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={(e) => {
              handleClose();
              e.preventDefault();
            }}
            id="editmodal"
            className=""
          >
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <label>POL</label>
                  <span className="red">*</span>
                  <Tooltip
                    title="PLACE OF LOADING/สถานที่ต้นทางที่ส่งออก"
                    placement="top-end"
                    arrow
                  >
                    <Autocomplete
                      id="free-solo-demo"
                      popupIcon={""}
                      pol
                      value={GET_POL}
                      options={polList}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          SET_POL(newValue.value);
                        } else {
                          SET_POL("");
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} variant="outlined" fullWidth />
                      )}
                      filterOptions={filterOptions}
                    />
                  </Tooltip>
                  {errors.pol && (
                    <span className="error-message">{errors.pol}</span>
                  )}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label>POD</label>
                  <span className="red">*</span>
                  <Tooltip
                    title="PLACE OF DELIVERY/สถานที่สุดท้ายที่จะส่งมอบสินค้าให้แก่ผู้ซื้อ"
                    placement="top-end"
                    arrow
                  >
                    <Autocomplete
                      id="free-solo-demo"
                      popupIcon={""}
                      pod
                      value={GET_POD}
                      options={podList}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          SET_POD(newValue.value);
                        } else {
                          SET_POD("");
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          fullWidth
                          maxSize="10"
                        />
                      )}
                      filterOptions={filterOptions}
                    />
                  </Tooltip>
                  {errors.pod && (
                    <span className="error-message">{errors.pod}</span>
                  )}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <label>DEL</label>
                  <Tooltip title="" placement="top-end" arrow>
                    <Autocomplete
                      popupIcon={""}
                      freeSolo={false}
                      del
                      value={GET_DEL}
                      options={delList}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          SET_DEL(newValue.value);
                        } else {
                          SET_DEL("");
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} variant="outlined" fullWidth />
                      )}
                      filterOptions={filterOptions}
                    />
                  </Tooltip>
                </Grid>

                {/* <Grid item xs={12} sm={12}>
                  <label className="label1">Service Type : </label>
                  <FormGroup row>
                    <FormControlLabel
                      control={<Checkbox defaultChecked />}
                      label="FCL"
                    />
                    <FormControlLabel control={<Checkbox />} label="LCL" />
                    <FormControlLabel control={<Checkbox />} label="Other" />
                  </FormGroup>
                </Grid> */}
                <Grid item xs={12} sm={12}>
                  {" "}
                  <label className="label1">Dry : </label>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <label> 20': </label>
                  <TextField
                    size="small"
                    name="GET_20"
                    variant="outlined"
                    fullWidth
                    id="GET_20"
                    value={GET_20}
                    onChange={(e) => SET_20(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label> 40': </label>

                  <TextField
                    size="small"
                    name="GET_40"
                    variant="outlined"
                    fullWidth
                    id="GET_40"
                    value={GET_40}
                    onChange={(e) => SET_40(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label> 40HQ':</label>
                  <TextField
                    size="small"
                    name="GET_40HQ"
                    variant="outlined"
                    fullWidth
                    id="GET_40HQ"
                    value={GET_40HQ}
                    onChange={(e) => SET_40HQ(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label> 45': </label>

                  <TextField
                    size="small"
                    name="GET_45"
                    variant="outlined"
                    fullWidth
                    id="GET_45"
                    value={GET_45}
                    onChange={(e) => SET_45(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <label className="label1">Reefer : </label>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label> 20': </label>
                  <TextField
                    size="small"
                    name="GET_20F"
                    variant="outlined"
                    fullWidth
                    id="GET_20F"
                    value={GET_20F}
                    onChange={(e) => SET_20F(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label> 40': </label>

                  <TextField
                    size="small"
                    name="GET_40F"
                    variant="outlined"
                    fullWidth
                    id="GET_40F"
                    value={GET_40F}
                    onChange={(e) => SET_40F(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label> ISO TANK:</label>
                  <TextField
                    size="small"
                    name="GET_ISOTANK"
                    variant="outlined"
                    fullWidth
                    id="GET_ISOTANK"
                    value={GET_ISOTANK}
                    onChange={(e) => SET_ISOTANK(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  &nbsp;
                </Grid>

                <Grid item xs={12} sm={3}>
                  <label> Special: </label>
                  <TextField
                    size="small"
                    name="GET_SPECIAL"
                    variant="outlined"
                    fullWidth
                    id="GET_SPECIAL"
                    value={GET_SPECIAL}
                    onChange={(e) => SET_SPECIAL(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <label> CBM: </label>

                  <TextField
                    size="small"
                    name="GET_CBM"
                    variant="outlined"
                    fullWidth
                    id="GET_CBM"
                    value={GET_CBM}
                    onChange={(e) => SET_CBM(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  &nbsp;
                </Grid>
                <Grid item xs={12} sm={12}>
                  <label className="label1">Shipment Type: </label>
                  <FormGroup row>
                    <FormControlLabel
                      control={<Checkbox defaultChecked />}
                      label="Import"
                    />
                    <FormControlLabel control={<Checkbox />} label="SOC" />
                    <FormControlLabel control={<Checkbox />} label="Food" />
                    <FormControlLabel control={<Checkbox />} label="Tire" />
                  </FormGroup>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <label className="label1">Inco-Term : </label>
                  <FormGroup row>
                    <FormControlLabel
                      control={<Checkbox defaultChecked />}
                      label="FOB"
                    />
                    <FormControlLabel control={<Checkbox />} label="CIF" />
                    <FormControlLabel control={<Checkbox />} label="CFR/CNF" />
                    <FormControlLabel control={<Checkbox />} label="Ex-work" />
                    <FormControlLabel control={<Checkbox />} label="FCA" />
                    <FormControlLabel control={<Checkbox />} label="DAP" />
                    <FormControlLabel control={<Checkbox />} label="DDU" />
                    <FormControlLabel control={<Checkbox />} label="DDP" />
                    <FormControlLabel control={<Checkbox />} label="Other" />
                  </FormGroup>
                </Grid>
              </Grid>
            </Container>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleClose}>
            Close
          </button>
          <button className="btn btn-primary" form="editmodal">
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddServiceDataModal;
